import React from "react";
import { classNames } from "src/common/classNames";
import { BlankLink, PropsBlankLink } from "src/components/BlankLink";

import * as styles from "./StdLink.module.less";

type PropsStdLink = PropsBlankLink & {
  underline?: boolean;
};
export const StdLink: React.FC<PropsStdLink> = ({
  children,
  onMouseDown,
  className,
  underline = true,
  ...props
}) => (
  <BlankLink
    {...props}
    className={classNames([
      styles.link,
      className,
      [underline, styles.underline],
    ])}
    onMouseDown={(e) => {
      // Это магическое действие необходимо, чтобы срабатывал клик на ссылку. Иначе событие клика не происходит.
      e.stopPropagation();
      e.preventDefault();
      onMouseDown?.(e);
    }}
  >
    {children}
  </BlankLink>
);
